/* Selector visual TCKC — sirve a The Cool Family y a ICONIC.
   Sin app: escribe line item properties en el formulario del producto.
   Horizon re-renderiza la seccion de producto de forma asincrona, asi que
   todo el estado vive en sessionStorage y se rehidrata cuando reaparece el bloque.
   Banderas por bloque:
     data-orden="libre"  -> sin arrastre ni flechas (el orden no importa)
     [data-tcf-buscar]   -> input de busqueda que filtra las fichas
     [data-tcf-limite]   -> aviso que aparece al llegar al maximo */
(function () {
  'use strict';

  /* Si hay dos bloques en la misma ficha, el tema inserta este archivo dos veces.
     Sin esta guarda los listeners se registran doble y cada clic suma dos veces. */
  if (window.__tckcSelectorListo) return;
  window.__tckcSelectorListo = true;

  var HYDRATED = 'data-tcf-hydrated';

  function libre(root) {
    return root.dataset.orden === 'libre';
  }

  function leer(root) {
    try {
      var raw = sessionStorage.getItem(root.dataset.key);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr : [];
    } catch (e) {
      return [];
    }
  }

  function guardar(root, lista) {
    try {
      sessionStorage.setItem(root.dataset.key, JSON.stringify(lista));
    } catch (e) {
      /* modo privado: seguimos igual, solo se pierde al recargar */
    }
  }

  function catalogo(root) {
    var mapa = {};
    root.querySelectorAll('[data-tcf-add]').forEach(function (tile) {
      mapa[tile.dataset.tcfAdd] = {
        label: tile.dataset.tcfLabel || tile.dataset.tcfAdd,
        src: tile.dataset.tcfSrc || (tile.querySelector('img') || {}).src || ''
      };
    });
    return mapa;
  }

  function chip(codigo, info, sinOrden) {
    var li = document.createElement('li');
    li.className = 'tckc-cf__chip';
    li.dataset.code = codigo;
    var html =
      '<img src="' + info.src + '" alt="' + info.label + '" width="220" height="220">' +
      '<button type="button" class="tckc-cf__chip-quitar" data-tcf-quitar aria-label="Quitar ' + info.label + '">&times;</button>';
    if (!sinOrden) {
      html +=
        '<button type="button" class="tckc-cf__chip-mover" data-dir="prev" aria-label="Mover ' + info.label + ' a la izquierda">&#8249;</button>' +
        '<button type="button" class="tckc-cf__chip-mover" data-dir="next" aria-label="Mover ' + info.label + ' a la derecha">&#8250;</button>';
    }
    li.innerHTML = html;
    return li;
  }

  function pintar(root) {
    var lista = leer(root);
    var mapa = catalogo(root);
    var sinOrden = libre(root);
    var max = parseInt(root.dataset.max, 10) || 12;
    var conteo = {};
    lista.forEach(function (c) {
      conteo[c] = (conteo[c] || 0) + 1;
    });

    root.querySelectorAll('[data-tcf-add]').forEach(function (tile) {
      var n = conteo[tile.dataset.tcfAdd] || 0;
      var badge = tile.querySelector('[data-tcf-count]');
      tile.dataset.selected = n > 0 ? 'true' : 'false';
      if (badge) {
        badge.textContent = String(n);
        badge.hidden = n === 0;
      }
    });

    var strip = root.querySelector('[data-tcf-strip]');
    if (strip) {
      strip.innerHTML = '';
      lista.forEach(function (c) {
        if (mapa[c]) strip.appendChild(chip(c, mapa[c], sinOrden));
      });
    }

    var vacio = root.querySelector('[data-tcf-vacio]');
    if (vacio) vacio.hidden = lista.length > 0;
    var ayuda = root.querySelector('[data-tcf-ayuda]');
    if (ayuda) ayuda.hidden = lista.length < 2;
    var limite = root.querySelector('[data-tcf-limite]');
    if (limite) limite.hidden = lista.length < max;
    var total = root.querySelector('[data-tcf-total]');
    if (total) total.textContent = lista.length ? '· ' + lista.length : '';

    var input = root.querySelector('[data-tcf-input]');
    if (input) {
      input.value = lista.join(', ');
      input.disabled = lista.length === 0;
    }
    var totalInput = root.querySelector('[data-tcf-total-input]');
    if (totalInput) {
      totalInput.value = String(lista.length);
      totalInput.disabled = lista.length === 0;
    }
  }

  function agregar(root, codigo) {
    var lista = leer(root);
    var max = parseInt(root.dataset.max, 10) || 12;
    if (lista.length >= max) {
      var limite = root.querySelector('[data-tcf-limite]');
      if (limite) {
        limite.hidden = false;
        limite.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
      return;
    }
    lista.push(codigo);
    guardar(root, lista);
    pintar(root);
  }

  function desdeDom(root) {
    var strip = root.querySelector('[data-tcf-strip]');
    if (!strip) return;
    var lista = [];
    strip.querySelectorAll('.tckc-cf__chip').forEach(function (li) {
      lista.push(li.dataset.code);
    });
    guardar(root, lista);
    pintar(root);
  }

  function normalizar(s) {
    return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  }

  function filtrar(root, texto) {
    var q = normalizar(texto).trim();
    root.querySelectorAll('[data-tcf-add]').forEach(function (tile) {
      var heno = normalizar(tile.dataset.tcfLabel + ' ' + tile.dataset.tcfAdd);
      tile.hidden = q !== '' && heno.indexOf(q) === -1;
    });
    root.querySelectorAll('.tckc-cf__group').forEach(function (g) {
      var visibles = g.querySelectorAll('[data-tcf-add]:not([hidden])').length;
      g.hidden = visibles === 0;
    });
  }

  /* --- eventos delegados: sobreviven al re-render de Horizon --- */

  document.addEventListener('click', function (ev) {
    var root = ev.target.closest('[data-tcf]');
    if (!root) return;

    var quitar = ev.target.closest('[data-tcf-quitar]');
    if (quitar) {
      ev.preventDefault();
      var li = quitar.closest('.tckc-cf__chip');
      if (li) li.remove();
      desdeDom(root);
      return;
    }

    var mover = ev.target.closest('.tckc-cf__chip-mover');
    if (mover) {
      ev.preventDefault();
      var actual = mover.closest('.tckc-cf__chip');
      if (!actual) return;
      if (mover.dataset.dir === 'prev' && actual.previousElementSibling) {
        actual.parentNode.insertBefore(actual, actual.previousElementSibling);
      } else if (mover.dataset.dir === 'next' && actual.nextElementSibling) {
        actual.parentNode.insertBefore(actual.nextElementSibling, actual);
      }
      desdeDom(root);
      return;
    }

    var tile = ev.target.closest('[data-tcf-add]');
    if (tile) {
      ev.preventDefault();
      agregar(root, tile.dataset.tcfAdd);
    }
  });

  document.addEventListener('input', function (ev) {
    var root = ev.target.closest('[data-tcf]');
    if (!root) return;
    if (!ev.target.matches('[data-tcf-buscar]')) return;
    filtrar(root, ev.target.value);
  });

  document.addEventListener('change', function (ev) {
    var root = ev.target.closest('[data-tcf]');
    if (!root) return;
    if (!ev.target.matches('[data-tcf-palabras]')) return;

    var wrap = root.querySelector('[data-tcf-texto-wrap]');
    var campo = root.querySelector('[data-tcf-texto]');
    if (!wrap || !campo) return;

    var pide = ev.target.selectedIndex > 0;
    wrap.hidden = !pide;
    campo.disabled = !pide;
    if (!pide) campo.value = '';
  });

  /* --- arrastre para reordenar (mouse y touch) --- */

  var arrastrando = null;

  document.addEventListener('pointerdown', function (ev) {
    var li = ev.target.closest('.tckc-cf__chip');
    if (!li) return;
    if (ev.target.closest('button')) return;
    var root = li.closest('[data-tcf]');
    if (!root || libre(root)) return;
    arrastrando = li;
    li.dataset.dragging = 'true';
    try {
      li.setPointerCapture(ev.pointerId);
    } catch (e) {
      /* algunos navegadores no lo permiten sobre <li> */
    }
  });

  document.addEventListener('pointermove', function (ev) {
    if (!arrastrando) return;
    ev.preventDefault();
    var bajo = document.elementFromPoint(ev.clientX, ev.clientY);
    var destino = bajo && bajo.closest ? bajo.closest('.tckc-cf__chip') : null;
    if (!destino || destino === arrastrando) return;
    if (destino.parentNode !== arrastrando.parentNode) return;

    var caja = destino.getBoundingClientRect();
    var despues = ev.clientX > caja.left + caja.width / 2;
    destino.parentNode.insertBefore(arrastrando, despues ? destino.nextSibling : destino);
  });

  function soltar() {
    if (!arrastrando) return;
    var root = arrastrando.closest('[data-tcf]');
    delete arrastrando.dataset.dragging;
    arrastrando = null;
    if (root) desdeDom(root);
  }

  document.addEventListener('pointerup', soltar);
  document.addEventListener('pointercancel', soltar);

  /* --- validacion del minimo antes de mandar al carrito --- */

  document.addEventListener(
    'submit',
    function (ev) {
      var form = ev.target;
      if (!form || form.tagName !== 'FORM') return;
      var roots = document.querySelectorAll('[data-tcf]');
      for (var i = 0; i < roots.length; i++) {
        var root = roots[i];
        var input = root.querySelector('[data-tcf-input]');
        if (!input || input.getAttribute('form') !== form.getAttribute('id')) continue;
        var min = parseInt(root.dataset.min, 10) || 0;
        if (min > 0 && leer(root).length < min) {
          ev.preventDefault();
          ev.stopPropagation();
          var aviso = root.querySelector('[data-tcf-vacio]');
          if (aviso) {
            aviso.hidden = false;
            aviso.textContent = 'Elige al menos ' + min + (min === 1 ? ' opción.' : ' opciones.');
          }
          root.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
      }
    },
    true
  );

  /* --- hidratacion: primera carga y cada re-render de la seccion --- */

  function hidratar() {
    document.querySelectorAll('[data-tcf]').forEach(function (root) {
      if (root.hasAttribute(HYDRATED)) return;
      root.setAttribute(HYDRATED, '');
      pintar(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hidratar);
  } else {
    hidratar();
  }

  var pendiente = null;
  new MutationObserver(function () {
    if (pendiente) return;
    pendiente = setTimeout(function () {
      pendiente = null;
      hidratar();
    }, 60);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
